import{j as r}from"./chunk-GEPA7FLG.js";r();var c=(i,l,t)=>{let o=i.length,n=l;for(let e=o;e>=1;e--)if(t[e]){n=t[e];break}return n};export{c as a};
//# sourceMappingURL=chunk-QTRFMGTH.js.map
